module.exports = __webpack_public_path__ + "img/icon_mail_sp.b845eca9.svg";